<template>
  <svg
    ref="icon"
    class="icon"
    :style="cssVars"
    :width="width"
    :height="height"
    :class="`icon--${iconName}`"
    aria-hidden="true"
    @mouseenter="getHoverIcon"
    @mouseleave="getDefaultIcon"
  >
    <use :href="svgLink"></use>
  </svg>
</template>

<script lang="js">
  export default  {
    name: 'ahc-icon',
    components: {

    },
    props: {
      iconName: {
        type: String,
        required: true,
      },
      iconNameHover: {
        type: String,
        default: null,
      },
      height: {
        type: String,
        default: "",
      },
      width: {
        type: String,
        default: "",
      },
      color: {
        type: String,
        default: '#2e2925'
      },
      colorHover: {
        type: String,
        default: '#0000ff'
      },
      focusParent: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      cssVars() {
          return {
            '--bg-color': this.color,
            '--hover-color': this.colorHover,
            '--height': (this.height) ? this.height + 'px' : 'auto',
            '--width': (this.width) ? this.width + 'px' : 'auto',
          }
      }
    },
    data() {
      return {
        svgLink: this.getLink(this.iconName),
      }
    },
    mounted () {
      // if this icon is wrapped in a focusable item, we can enable a,
      // icon swap when that parent item is focused.
      if(this.focusParent) {
        const parent = this.$el.parentElement;
        parent.addEventListener('focus', this.getHoverIcon);
        parent.addEventListener('blur', this.getDefaultIcon);
      }
    },
    destroyed() {
      if(this.focusParent) {
        const parent = this.$el.parentElement;
        parent.removeEventListener('focus', this.getHoverIcon);
        parent.removeEventListener('blur', this.getDefaultIcon);
      }
    },
    methods: {
      getLink: (iconName) => {
        return `/app/themes/ahc/src/assets/images/icons.svg#${iconName}`
      },
      getHoverIcon() {
        this.svgLink = (this.iconNameHover) ? this.getLink(this.iconNameHover) : this.getLink(this.iconName);
      },
      getDefaultIcon() {
        this.svgLink = this.getLink(this.iconName);
      }
    },
}
</script>

<style lang="scss" scoped>
  svg {
    fill: var(--bg-color);
    height: var(--height);
    width: var(--width);
  }
  svg:hover {
    fill: var(--hover-color);
  }
</style>